import React from 'react';
import { useLanguage } from '../../i18n/LanguageContext.jsx';

const PhoneInput = ({ value, onChange, onKeyPress }) => {
  const { t } = useLanguage();
  const handleChange = (e) => {
    const newValue = e.target.value;

    // Always ensure +40 prefix
    if (!newValue.startsWith('+40')) {
      // If user tries to delete +40, restore it
      onChange('phone_number', '+40');
    } else {
      onChange('phone_number', newValue);
    }
  };

  return (
    <div className="mb-6">
      <label className="block text-sm font-semibold text-neutral-600 mb-3 ml-2">
        {t('login.phone')}
      </label>
      <div className="bg-white rounded-2xl border-2 border-gray-200 focus-within:border-primary focus-within:shadow-[0_0_0_4px_rgba(0,90,224,0.1)] transition-all duration-200">
        <div className="flex items-center">
          <span className="pl-5 text-base text-neutral-600 font-medium select-none">+40</span>
          <input
            type="tel"
            className="flex-1 h-14 px-2 text-base text-neutral-600 bg-transparent border-none outline-none placeholder-neutral-400 rounded-2xl"
            placeholder="723 456 789"
            value={value.startsWith('+40') ? value.substring(3) : value}
            onChange={(e) => onChange('phone_number', '+40' + e.target.value)}
            onKeyPress={onKeyPress}
            autoCapitalize="none"
          />
        </div>
      </div>
    </div>
  );
};

export default PhoneInput;
